import styled from 'styled-components'

export const NotificationsCreatorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 40px 60px;
  width: 75vw;
`
